import { FC, useState } from 'react';
import { Button, DefaultFooterComponent, Popup, showAlert } from '@silverfort/sf-components';
import EntitiesSearch from '../EntitiesSearch';
import { httpPost } from '../../../utils';
import { USER_MANAGEMENT_BASE_URL } from '../../api/consts';
import { ROLES } from '@silverfort-nodelibs/common/utils/consts';
import { isUserPermitted } from '../../../../TowerMenu/TowerMenuUtils';
import { Entity, UserSession } from '../../../../api';

interface Props {
    buttonLabel?: string;
    userSession?: UserSession;
    savedProtectedEntities: Entity[];
    onUpdateProtectedEntities: () => void;
}

const ManageProtectedGroups: FC<Props> = ({
    buttonLabel = 'Edit Users',
    userSession,
    savedProtectedEntities,
    onUpdateProtectedEntities
}) => {
    const [open, setOpen] = useState(false);
    const [selectedEntities, setSelectedEntities] = useState<Entity[]>(savedProtectedEntities);

    const updateProtectedGroups = async (entities: Entity[]) => {
        try {
            await httpPost(`${USER_MANAGEMENT_BASE_URL}/protectedEntities`, { entities }, {});
            onUpdateProtectedEntities();
            showAlert('Changes will soon be reflected in the table.', 'success', { title: 'Protected users updated' });
        } catch (err) {
            showAlert(`An error occurred while updating protected users.`, 'error', {
                title: 'Failed to updated protected users'
            });
        }
    };

    return (
        <>
            <Button
                text={buttonLabel}
                onClick={() => setOpen(true)}
                disabled={!isUserPermitted(userSession, 'manageProtectedGroups', ROLES.EDITOR.value)}
            />
            <Popup
                open={open}
                title="Add Users"
                ContentComponent={() => (
                    <EntitiesSearch
                        selectedEntities={selectedEntities}
                        onSelectedEntitiesChange={setSelectedEntities}
                    />
                )}
                FooterComponent={DefaultFooterComponent}
                initialState={{}}
                FooterComponentProps={{
                    primaryButtonProps: {
                        text: 'Done'
                    },
                    secondaryButtonProps: {
                        text: 'Back'
                    }
                }}
                popupClassName="w-[544px] h-[504px]"
                contentClassName="py-0 px-2"
                onClose={() => setOpen(false)}
                onApprove={() => updateProtectedGroups(selectedEntities)}
            />
        </>
    );
};

export default ManageProtectedGroups;
